const $ = jQuery.noConflict();

'use strict';
const infoList = {
	$domLoadBtn: $('.js-info-list-load-btn'),

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$('li[data-item="6"]').nextAll().hide();
		this.$domLoadBtn.on('click', function() {
			infoList.toggleList();
		});
	},

	toggleList: function() {
		$('li[data-item="6"]').nextAll().slideToggle('medium');

		if (this.$domLoadBtn.text() === 'See more') {
			this.$domLoadBtn.text('See less');
		} else {
			this.$domLoadBtn.text('See more');
		}
	},
};

export default infoList;